import React from "react";

export default function Footer() {
  return (
    <footer className="bg-blue-600 text-white text-center py-6 mt-12">
      <p>© {new Date().getFullYear()} Daniel Mirigi. All rights reserved.</p>
    </footer>
  );
}
